$(document).ready(function () {
    // слайдер Swiper
    const slider_previews_with_banner = new Swiper('#slider-previews-with-bannerSlider', {
        // Optional parameters
        loop: true,

        breakpoints: {
            375: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
            1075: {
                slidesPerView: 2,
                spaceBetween: 551, // 47+469+47-12
            }
        },

        // Pagination
        pagination: {
            el: '#slider-previews-with-banner__sliderWrap .swiper-pagination',
            clickable: true,
        },

        // Navigation arrows
        navigation: {
            nextEl: '#slider-previews-with-banner__sliderWrap .swiper-button-next',
            prevEl: '#slider-previews-with-banner__sliderWrap .swiper-button-prev',
        }
    });
});
